import React, { useEffect, useState } from 'react';
import { organisationsAPI } from '../../../organisations/api/organisationsAPI';
import { appUrl } from '../../../../config/appBase';
import { organisationErrorMessage } from '../../../organisations/lib/errorMessage';

/**
 * School tab: the organisation's name and the link students join it with,
 * from GET /api/organisations/<id>/student-link.
 *
 * The staff code is never fetched or shown here: PathBuddy issues it to the
 * school directly, because it opens every student in the school. There is
 * no staff list: no endpoint lists an organisation's staff yet.
 */
const SchoolTab = ({ organisation }) => {
  const [link, setLink] = useState(null);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLink(null);
    setError('');
    setCopied(false);
    organisationsAPI.getStudentLink(organisation.id)
      .then((data) => { if (!cancelled) setLink(appUrl(data.path)); })
      .catch((err) => {
        if (!cancelled) setError(organisationErrorMessage(err, 'Could not load the student link. Please try again.'));
      });
    return () => { cancelled = true; };
  }, [organisation.id]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
    } catch {
      setError('Could not copy the link. Select it and copy it instead.');
    }
  };

  return (
    <div className="td-school">
      <h2 className="td-students__title">{organisation.name}</h2>

      <section className="td-card">
        <h3 className="td-card__title">Student link</h3>
        <p className="td-card__body">
          Students who sign up or sign in through this link join {organisation.name} automatically.
        </p>
        {error ? <div className="td-error">{error}</div> : null}
        {link ? (
          <div className="td-linkrow">
            <input className="td-linkrow__url" value={link} readOnly aria-label="Student join link" onFocus={(e) => e.target.select()} />
            <button type="button" className="td-btn td-btn--confirm" onClick={copy}>
              {copied ? 'Link copied' : 'Copy link'}
            </button>
          </div>
        ) : null}
        {!link && !error ? <p className="td-loading">Loading…</p> : null}
      </section>

      <section className="td-card">
        <h3 className="td-card__title">Staff code</h3>
        <p className="td-card__body">
          Staff join with a staff code, which PathBuddy issues to your school directly. It is
          never shown here, because anyone with it can see every student in the school.
        </p>
      </section>
    </div>
  );
};

export default SchoolTab;
